import React from 'react';
import { TextField, Flex, Text, TextArea, Button } from "@radix-ui/themes";
import Icon from '@mdi/react';
import { mdiContentSave, mdiClose, mdiDelete } from '@mdi/js';
import { api } from '../services/api';
import { useStore } from '../store/store';

export const SidebarLocEdit = (props) => {
    const [state, actions] = useStore();
    const [temporaryLocation, setTemporaryLocation] = React.useState(props.selectedLocation);
    const [focusedField, setFocusedField] = React.useState(null);
    
    React.useEffect(() => {
        setTemporaryLocation(props.selectedLocation);
    }, [props.selectedLocation]);

    const saveLocation = async () => {
        try {
            // Save to API
            if(temporaryLocation.new === true) {
                await api.createLocation(state.currentNovel.id, temporaryLocation);
            } else {
                await api.updateLocation(temporaryLocation.id, temporaryLocation);
            }

            
            // Update the novels in the store
            const updatedNovels = state.novels.map(novel => {
                if (novel.locations) {
                    if (temporaryLocation.new === true) {
                        // Add the new location to the novel's locations array
                        return { ...novel, locations: [...novel.locations, temporaryLocation] };
                    } else {
                        // Update the existing location in the novel's locations array
                        const updatedLocations = novel.locations.map(location => 
                            location.id === temporaryLocation.id ? temporaryLocation : location
                        );
                        return { ...novel, locations: updatedLocations };
                    }
                }
                return novel;
            });
            actions.setNovels(updatedNovels);
            
            // Update the current novel in the store if it exists
            if (state.currentNovel) {
                if (temporaryLocation.new === true) {
                    // Add the new location to the current novel's locations array
                    const updatedLocations = [...(state.currentNovel.locations || []), temporaryLocation];
                    
                    const updatedCurrentNovel = {
                        ...state.currentNovel,
                        locations: updatedLocations
                    };
                    
                    actions.setCurrentNovel(updatedCurrentNovel);
                } else {
                    // Update the existing location in the current novel's locations array
                    const updatedLocations = state.currentNovel.locations?.map(location => 
                        location.id === temporaryLocation.id ? temporaryLocation : location
                    ) || [];
                    
                    const updatedCurrentNovel = {
                        ...state.currentNovel,
                        locations: updatedLocations
                    };
                    
                    actions.setCurrentNovel(updatedCurrentNovel);
                }
            }

            // Reset the new flag if it was a new location
            if (temporaryLocation.new) {
                setTemporaryLocation({...temporaryLocation, new: false});
            }
        } catch (error) {
            console.error("Failed to save location:", error);
        }
    }

    const deleteLocation = async () => {
        try {
            // Delete from API
            await api.deleteLocation(temporaryLocation.id);
            
            // Update novels in the store by filtering out the deleted location
            const updatedNovels = state.novels.map(novel => {
                if (novel.locations) {
                    return {
                        ...novel,
                        locations: novel.locations.filter(location => location.id !== temporaryLocation.id)
                    };
                }
                return novel;
            });
            actions.setNovels(updatedNovels);
            
            // Update the current novel in the store
            if (state.currentNovel && state.currentNovel.locations) {
                const updatedCurrentNovel = {
                    ...state.currentNovel,
                    locations: state.currentNovel.locations.filter(location => 
                        location.id !== temporaryLocation.id
                    )
                };
                actions.setCurrentNovel(updatedCurrentNovel);
            }
            
            // Close the location editor
            props.setSelectedLocation(null);
        } catch (error) {
            console.error("Failed to delete location:", error);
        }
    }

    return (
        <div className='sidebar-sidebar'>
            <div style={{textAlign: 'right', cursor: 'pointer'}} onClick={() => props.setSelectedLocation(null)}>
                <Icon path={mdiClose} color={'#FFFFFF50'} size={1} />
            </div>
            <div className="sidebar-form">
                <Flex direction="column" align={'start'}>
                    <Text size={"2"} className="sidebar-form-textInput-label">Name</Text>
                    {state.readOnly ? (
                        <div className="sidebar-form-textInput read-only-field">{temporaryLocation?.name ?? ''}</div>
                    ) : (
                        <TextField.Root style={{width: "300px"}} className="sidebar-form-textInput" placeholder="Name" value={temporaryLocation?.name ?? ''} variant="soft" onChange={(e) => {
                            setTemporaryLocation({...temporaryLocation, name: e.target.value});
                        }} />
                    )}
                </Flex>
                <br />
                <Flex direction="column" align={'start'}>
                    <Text size={"2"} as="div" className="sidebar-form-textInput-label">Description</Text>
                    {state.readOnly ? (
                        <div className="sidebar-form-textInput read-only-field sidebar-form-textInput-big">{temporaryLocation?.description ?? ''}</div>
                    ) : (
                        <TextArea 
                            className={`sidebar-form-textInput sidebar-form-textInput-big`} 
                            placeholder="Name" 
                            value={temporaryLocation?.description ?? ''} 
                            variant="soft" 
                            onFocus={() => setFocusedField('descr')}
                            onBlur={() => setFocusedField(null)}
                            onChange={(e) => {
                                setTemporaryLocation({...temporaryLocation, description: e.target.value});
                            }} 
                        />
                    )}
                </Flex>
            </div>
            {!state.readOnly && (
                <div>
                    <Flex justify={'between'} gap="20px">
                        <Button color="green" style={{width: '80%', marginTop: '20px', cursor: 'pointer'}} onClick={() => {saveLocation();}
                        }>
                            <Icon path={mdiContentSave} size={1} />
                            Save Location
                        </Button>
                        <Button color="red" style={{width: 'calc(20% - 20px)', marginTop: '20px', cursor: 'pointer'}} onClick={() => {deleteLocation();}
                        }>
                            <Icon path={mdiDelete} size={1} />
                        </Button>
                    </Flex>
                </div>
            )}
        </div>
    );
};

export default SidebarLocEdit;